import { render, staticRenderFns } from "./ChatBot.vue?vue&type=template&id=1e9f556c&scoped=true&"
import script from "./ChatBot.vue?vue&type=script&lang=js&"
export * from "./ChatBot.vue?vue&type=script&lang=js&"
import style0 from "./ChatBot.vue?vue&type=style&index=0&id=1e9f556c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9f556c",
  null
  
)

export default component.exports